import { createFileRoute } from '@tanstack/react-router';
import { PersonProfileLayout } from '@/pages/workspaces/people/person/person-profile-layout';
import { LastWorkspaceResolver } from './-route-helpers';

/**
 * The person profile's frame, around every tab beneath `/people/:personId`. It mounts once while
 * the user moves between tabs, so the header and menus stay put and the person is read once.
 * The sentinel resolver is outermost, as on each tab: the frame reads the current workspace.
 */
function PersonProfileLayoutRoute() {
  const { personId } = Route.useParams();

  return (
    <LastWorkspaceResolver>
      <PersonProfileLayout personId={personId} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/people/$personId')({
  component: PersonProfileLayoutRoute,
});
